
import AdjustmentDataDialog from '@/components/barcode/AdjustmentDataDialog.vue'
import BarcodeRowMixin from '@/components/mixins/BarcodeRowMixin.vue'
import IconAddressLocation from '@/components/svg/IconAddressLocation.vue'
import IconCopy from '@/components/svg/IconCopy.vue'
import { Options } from 'vue-class-component'
import { Mixins, Prop } from 'vue-property-decorator'

@Options({
  components: {
    IconCopy,
    IconAddressLocation,
    AdjustmentDataDialog,
  },
  name: 'BarcodeRow',
})
export default class BarcodeRow extends Mixins(BarcodeRowMixin) {
  @Prop({ type: String }) readonly label?: string
  @Prop({ type: String }) readonly customFieldKey?: string
  @Prop({ type: String }) readonly adjustment?: string
  @Prop({ type: String }) readonly currentValue?: string

  isShowModal = false

  onShowAdjustment() {
    this.isShowModal = true
  }
}
